import { Http } from '@intelipost-js/secure-providers';

export default {
  getAlgoliaToken(context) {
    return Http.get('api/v1/user/algolia_token')
      .then(res => context.commit('setAlgoliaToken', res.data.content));
  },
  exportToExcel({ commit }, params) {
    commit('toogleLoadingExport', true);

    return Http.post('api/v1/shipment_table/excel_algolia', params)
      .then((res) => {
        commit('toogleLoadingExport', false);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toogleLoadingExport', false);
        return Promise.resolve(err);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/transactions/store/actions.js